// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_SbzvE {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	border-bottom: 5px solid var(--background);
  /*var( --border-color );*/
	padding-right: 20px;
}

.header_SbzvE .rndBtn_l3clo {
	border-radius: 50%;
	width: 40px;
	height: 40px;
}

.header_SbzvE .rndBtn_l3clo:focus,
.header_SbzvE .rndBtn_l3clo:active,
.header_SbzvE .rndBtn_l3clo:focus:active {
	box-shadow: none;
	outline: none;
}

.tools_NpBRA {
	position: absolute;
	z-index: 10;
	display : flex;
	gap : 4px;
	padding: 4px;
	right : 0;
}

.zoomWrapper_aDhTb {
	position: absolute;
	top:0;
	bottom: 0;
	left: 0;
	right: 0;
}

.tools_NpBRA + .react-transform-wrapper {
	position: absolute;
	top:0;
	bottom: 0;
	left: 0;
	right: 0;
	width: unset;
	height : unset;
}

.list_LjE2k {
	height: 100%;
}

.flowLegend_GFxVQ {
	position : absolute;
	right : 0;
	bottom : 0;
}

.oneToOneFlowLink_wlMff {
	background-color: #ffc;
	color: black;
	border: 1px solid #663;
	padding: 4px;
	font-size: 10px;
}

.oneToManyFlowLink_lpCDw {
	background-color: #fcf;
	color: black;
	border: 1px solid #959;
	padding: 4px;
	font-size: 10px;
}

.manyToOneFlowLink_rmr9W {
	background-color: #cff;
	color: black;
	border: 1px solid #599;
	padding: 4px;
	font-size: 10px;
}

.manyToManyFlowLink_mAA20 {
	background-color: #fcc;
	color: black;
	border: 1px solid #955;
	padding: 4px;
	font-size: 10px;
}


.deviceFlowNode_sAf9T {
	padding: 4px;
	font-size: 14px;
}


.addTypeButton_onzxp {
	text-align: center;
	user-select: none;
}

.addTypeButton_onzxp:hover {
	background: var(--purple-5);
}

.addTypeButton_onzxp:active {
	background: var(--purple-10);
}

.addTypeButton_onzxp p {
	text-align: justify;
	font-weight: 300;
}

.addTypeButton_onzxp > i {
	font-size: 36px;
	color: var(--light-grey);
	border: 7px solid var(--light-grey);
	border-radius: 50%;
	padding: 20px;
	width: 90px;
	height: 90px;
	margin: 10px;
}

.addTypeButton_onzxp:hover > i {
	color: var(--purple);
	border-color: var(--purple);
}`, "",{"version":3,"sources":["webpack://./src/screens/blueprint/blueprintsScreen.css"],"names":[],"mappings":"AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,0CAA0C;EACzC,yBAAyB;CAC1B,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;;;CAGC,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,cAAc;CACd,SAAS;CACT,YAAY;CACZ,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,KAAK;CACL,SAAS;CACT,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,KAAK;CACL,SAAS;CACT,OAAO;CACP,QAAQ;CACR,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,sBAAsB;CACtB,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,sBAAsB;CACtB,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,sBAAsB;CACtB,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,sBAAsB;CACtB,YAAY;CACZ,eAAe;AAChB;;;AAGA;CACC,YAAY;CACZ,eAAe;AAChB;;;AAGA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,wBAAwB;CACxB,mCAAmC;CACnC,kBAAkB;CAClB,aAAa;CACb,WAAW;CACX,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,oBAAoB;CACpB,2BAA2B;AAC5B","sourcesContent":["@import \"../../style/theme.css\";\n\n.header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\tborder-bottom: 5px solid var(--background);\n  /*var( --border-color );*/\n\tpadding-right: 20px;\n}\n\n.header .rndBtn {\n\tborder-radius: 50%;\n\twidth: 40px;\n\theight: 40px;\n}\n\n.header .rndBtn:focus,\n.header .rndBtn:active,\n.header .rndBtn:focus:active {\n\tbox-shadow: none;\n\toutline: none;\n}\n\n.tools {\n\tposition: absolute;\n\tz-index: 10;\n\tdisplay : flex;\n\tgap : 4px;\n\tpadding: 4px;\n\tright : 0;\n}\n\n.zoomWrapper {\n\tposition: absolute;\n\ttop:0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n.tools + :global(.react-transform-wrapper) {\n\tposition: absolute;\n\ttop:0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\twidth: unset;\n\theight : unset;\n}\n\n.list {\n\theight: 100%;\n}\n\n.flowLegend {\n\tposition : absolute;\n\tright : 0;\n\tbottom : 0;\n}\n\n.oneToOneFlowLink {\n\tbackground-color: #ffc;\n\tcolor: black;\n\tborder: 1px solid #663;\n\tpadding: 4px;\n\tfont-size: 10px;\n}\n\n.oneToManyFlowLink {\n\tbackground-color: #fcf;\n\tcolor: black;\n\tborder: 1px solid #959;\n\tpadding: 4px;\n\tfont-size: 10px;\n}\n\n.manyToOneFlowLink {\n\tbackground-color: #cff;\n\tcolor: black;\n\tborder: 1px solid #599;\n\tpadding: 4px;\n\tfont-size: 10px;\n}\n\n.manyToManyFlowLink {\n\tbackground-color: #fcc;\n\tcolor: black;\n\tborder: 1px solid #955;\n\tpadding: 4px;\n\tfont-size: 10px;\n}\n\n\n.deviceFlowNode {\n\tpadding: 4px;\n\tfont-size: 14px;\n}\n\n\n.addTypeButton {\n\ttext-align: center;\n\tuser-select: none;\n}\n\n.addTypeButton:hover {\n\tbackground: var(--purple-5);\n}\n\n.addTypeButton:active {\n\tbackground: var(--purple-10);\n}\n\n.addTypeButton p {\n\ttext-align: justify;\n\tfont-weight: 300;\n}\n\n.addTypeButton > i {\n\tfont-size: 36px;\n\tcolor: var(--light-grey);\n\tborder: 7px solid var(--light-grey);\n\tborder-radius: 50%;\n\tpadding: 20px;\n\twidth: 90px;\n\theight: 90px;\n\tmargin: 10px;\n}\n\n.addTypeButton:hover > i {\n\tcolor: var(--purple);\n\tborder-color: var(--purple);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_SbzvE`,
	"rndBtn": `rndBtn_l3clo`,
	"tools": `tools_NpBRA`,
	"zoomWrapper": `zoomWrapper_aDhTb`,
	"list": `list_LjE2k`,
	"flowLegend": `flowLegend_GFxVQ`,
	"oneToOneFlowLink": `oneToOneFlowLink_wlMff`,
	"oneToManyFlowLink": `oneToManyFlowLink_lpCDw`,
	"manyToOneFlowLink": `manyToOneFlowLink_rmr9W`,
	"manyToManyFlowLink": `manyToManyFlowLink_mAA20`,
	"deviceFlowNode": `deviceFlowNode_sAf9T`,
	"addTypeButton": `addTypeButton_onzxp`
};
export default ___CSS_LOADER_EXPORT___;
